// @flow
import { type Event, getEventCategoryProducts, getEventCategoryCreateProduct } from './config';
import type { Filters } from '../../app/products/toolbar/ToolbarComponent';
import { APPROVAL_STATUS } from '../../api/types/Approvals';

const singleDelete = (): Event => ({
  category: getEventCategoryProducts(),
  action: 'Delete',
  label: 'Single',
});

const bulkDelete = (): Event => ({
  category: getEventCategoryProducts(),
  action: 'Delete',
  label: 'Bulk',
});

const singleAddToCart = (approvalStatus: string = ''): Event => ({
  category: getEventCategoryProducts(),
  action: 'Add to cart',
  label: approvalStatus && approvalStatus !== APPROVAL_STATUS.notApplicable ? `Single || ${approvalStatus}` : 'Single',
});

const bulkAddToCart = (): Event => ({
  category: getEventCategoryProducts(),
  action: 'Add to cart',
  label: 'Bulk',
});

const nameUpdate = (): Event => ({
  category: getEventCategoryProducts(),
  action: 'Rename',
  label: 'Single',
});

const productSearch = (): Event => ({
  category: getEventCategoryProducts(),
  action: 'Search',
  label: 'Products',
});

const productSelectAll = (): Event => ({
  category: getEventCategoryProducts(),
  action: 'Select all',
  label: 'Select',
});

const productDeselectAll = (): Event => ({
  category: getEventCategoryProducts(),
  action: 'Select all',
  label: 'Deselect',
});

const searchTemplate = (): Event => ({
  category: getEventCategoryCreateProduct(),
  action: 'Search',
  label: 'Templates',
});

const backButtonNewProduct = (): Event => ({
  category: getEventCategoryCreateProduct(),
  action: 'Click',
  label: 'New product back',
});

const closeButtonNewProduct = (): Event => ({
  category: getEventCategoryCreateProduct(),
  action: 'Click',
  label: 'New product close',
});

const getStartedButtonNewProduct = (): Event => ({
  category: getEventCategoryCreateProduct(),
  action: 'Click',
  label: 'Get started',
});

const guidelinesNewProduct = (): Event => ({
  category: getEventCategoryCreateProduct(),
  action: 'Click',
  label: 'Guidelines and templates',
});

const sizeNewProduct = (size: string = 'No Size Selected'): Event => ({
  category: getEventCategoryCreateProduct(),
  action: 'Click',
  label: `Size || ${size}`,
});

const elementNewProduct = (element: string = 'No Element Selected'): Event => ({
  category: getEventCategoryCreateProduct(),
  action: 'Click',
  label: `Element || ${element}`,
});

const createNewProduct = (flow: string = '') => ({
  category: getEventCategoryProducts(),
  action: 'Click',
  label: `Create || ${flow}`,
});

const typeSelect = (type: string = '') => ({
  category: getEventCategoryProducts(),
  action: 'Click',
  label: `Product type || ${type}`,
});

const filterProducts = (updatedFilters: Filters) => {
  const { templateFilter, sortFilter, sizeFilter } = updatedFilters;

  let template = templateFilter;
  if (templateFilter !== 'ALL') {
    template = 'Template';
  }

  return {
    category: getEventCategoryProducts(),
    action: 'Filter',
    label: `${template} ${sizeFilter} ${sortFilter}`,
  };
};

const tileAction = (label: string = '') => ({
  category: getEventCategoryProducts(),
  action: 'Click',
  label,
});

const paperPicker = (paperOption: string = '') => ({
  category: getEventCategoryProducts(),
  action: 'Click',
  label: `Paper Picker || ${paperOption}`,
});

const newProductCreated = (productType: string = '') => ({
  category: getEventCategoryProducts(),
  action: 'Toast',
  label: `Created || ${productType}`,
});

const productEdited = (productType: string = '') => ({
  category: getEventCategoryProducts(),
  action: 'Toast',
  label: `Edited || ${productType}`,
});

const productSubmittedForApproval = (productType: string = '') => ({
  category: getEventCategoryProducts(),
  action: 'Toast',
  label: `Submitted for Approval || ${productType}`,
});

const emptyState = () => ({
  category: getEventCategoryProducts(),
  action: 'Empty state',
  label: 'Empty',
});

const renameError = (errorReason: string = '') => ({
  category: getEventCategoryProducts(),
  action: 'Error',
  label: `Rename || ${errorReason}`,
});

const tooltipHover = (text: string = '') => ({
  category: getEventCategoryProducts(),
  action: 'Hover',
  label: `Tooltip || ${text}`,
});

export default {
  singleDelete,
  bulkDelete,
  singleAddToCart,
  bulkAddToCart,
  nameUpdate,
  productSearch,
  productSelectAll,
  productDeselectAll,
  searchTemplate,
  backButtonNewProduct,
  closeButtonNewProduct,
  getStartedButtonNewProduct,
  guidelinesNewProduct,
  sizeNewProduct,
  elementNewProduct,
  createNewProduct,
  typeSelect,
  filterProducts,
  tileAction,
  newProductCreated,
  emptyState,
  paperPicker,
  renameError,
  productEdited,
  productSubmittedForApproval,
  tooltipHover,
};
